import { render } from "./App.vue?vue&type=template&id=08d87bf4&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=08d87bf4&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d87bf4"]])

export default __exports__